"use client"

import Link from "next/link"
import { Mail, MessageCircle } from "lucide-react"
import type { PortfolioData } from "@/types/portfolio"

interface FooterProps {
  data: PortfolioData
}

const navLinks = [
  { href: "#funcionalidades", label: "Plataforma" },
  { href: "#resultados", label: "Resultados" },
  { href: "#como-funciona", label: "Cómo funciona" },
  { href: "#faq", label: "Preguntas frecuentes" },
  { href: "#contacto", label: "Contacto" },
]

export function Footer({ data }: FooterProps) {
  const { profile, contact } = data

  return (
    <footer className="bg-[#004d52] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 sm:py-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-10 sm:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link href="/" className="inline-block mb-4">
              <h3 className="text-xl font-semibold">{profile.name}</h3>
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-6 max-w-sm">
              {profile.tagline}
            </p>
            <div className="flex gap-3">
              <a
                href={`mailto:${contact.email}`}
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="Correo"
              >
                <Mail className="h-5 w-5" />
              </a>
              <a
                href={contact.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white/50">
              Navegación
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={profile.ctaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-white transition-colors"
                >
                  Solicitar demo
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white/50">
              Contacto
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a href={`mailto:${contact.email}`} className="hover:text-white transition-colors">
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={contact.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  +52 238 273 0259
                </a>
              </li>
              <li>
                <a
                  href={profile.ctaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 font-medium text-[#F97316] hover:text-[#fb923c] transition-colors"
                >
                  {profile.ctaText}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
